import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getConsent, setConsent } from '@/features/analytics/cookies';
import '@/features/analytics/analytics.css';

type Props = {
  onChange?: (choice: 'accepted' | 'rejected') => void;
};

export function CookieConsentBanner({ onChange }: Props) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(getConsent() === null);
  }, []);

  function choose(choice: 'accepted' | 'rejected') {
    setConsent(choice);
    setVisible(false);
    onChange?.(choice);
  }

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-labelledby="cookie-banner-title" aria-live="polite">
      <div className="cookie-banner-inner">
        <div className="cookie-banner-copy">
          <strong id="cookie-banner-title">Cookies & mesure d’audience</strong>
          <p>
            Nous utilisons des cookies essentiels (session, préférences) et, avec votre accord, des cookies
            de mesure d’audience pour comprendre le parcours des visiteurs sur le site. Aucune pub tierce.
            Détails dans la{' '}
            <Link to="/politique-de-confidentialite">politique de confidentialité</Link>.
          </p>
        </div>
        <div className="cookie-banner-actions">
          <button type="button" className="btn btn-ghost" onClick={() => choose('rejected')}>
            Refuser
          </button>
          <button type="button" className="btn btn-primary" onClick={() => choose('accepted')}>
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
}
